import { Button, TableItem, TableMessage } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { useNewWindowNavigate } from 'hooks/useNewWindowNavigate';
import { t } from 'i18next';
import { PiNavigationArrow, PiPlus, PiTrash } from 'react-icons/pi';
import { IClientAccountForm } from 'services/client-account/types';
import { useGetTrackLightList } from 'services/tracks/light';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const ClientAccountTracks = () => {
  const tracksLightList = useGetTrackLightList();

  const { values, setFieldValue, status, initialStatus } =
    useFormikContext<IClientAccountForm>();

  const navigateToNewWindow = useNewWindowNavigate();

  const trackOptions = (tracks: string[]) =>
    tracksLightList.data
      ?.filter(track => !tracks.includes(track.id))
      .map(track => ({
        label: track.mainTitle,
        value: track.id,
      })) ?? [];

  const goToTrack = (id: string) => {
    navigateToNewWindow(`track/${id}`);
  };

  return (
    <Table
      displayMode
      data={{
        nodes:
          values.tracks?.map((track, key) => ({
            id: key,
            value: track.id,
            label: track.name,
          })) ?? [],
      }}
      columns={[
        {
          label: t('input.label.track'),
          renderCell: ({ label, value, id }) => (
            <TableItem>
              {status?.displayMode ? (
                <TableItem.Text text={label} />
              ) : (
                <FormInput.Select
                  name={`tracks[${id}].id`}
                  label={t('input.label.track')}
                  options={trackOptions(values.tracks?.map(track => track.id))}
                  onChange={option => {
                    setFieldValue(`tracks[${id}].id`, option.value);
                    setFieldValue(`tracks[${id}].name`, option.label);
                  }}
                  value={{ label: label ?? '-', value: value }}
                />
              )}
            </TableItem>
          ),
        },

        {
          label: '',
          renderCell: ({ value }) => (
            <TableItem justifyPosition='end'>
              {status?.displayMode ? (
                <Button isClear onlyIcon onClick={() => goToTrack(value)}>
                  <Button.Icon
                    icon={<PiNavigationArrow transform='scale(-1,1)' />}
                  />
                </Button>
              ) : (
                <Button
                  variant={BUTTON_VARIANT.remove}
                  isClear
                  onlyIcon
                  onClick={() =>
                    setFieldValue(
                      `tracks`,
                      values.tracks?.filter(track => track.id !== value)
                    )
                  }>
                  <Button.Icon icon={<PiTrash />} />
                </Button>
              )}
            </TableItem>
          ),
        },
      ]}
      tableOptions={
        status?.displayMode
          ? undefined
          : {
              renderAfterTable: () => (
                <tfoot className='full-width-footer'>
                  <TableMessage
                    className='cursor-pointer'
                    disable={
                      values.tracks?.length
                        ? !values.tracks[values.tracks.length - 1]?.id.length
                        : false
                    }
                    onClick={() =>
                      setFieldValue(`tracks[${values.tracks?.length ?? 0}]`, {
                        id: '',
                        name: '',
                      })
                    }>
                    <TableItem.Text text={t('button.add')} />
                    <PiPlus />
                  </TableMessage>
                </tfoot>
              ),
            }
      }
      size='compact'
    />
  );
};

export default ClientAccountTracks;
